<template>
    <Layout is-crm class="order-statistic-page" :content-class="'content--narrow'">
        <template #default>
            <Spinner v-if="loading" />
            <header class="page__top">
                <h1 v-t="'crm.statistic.title'"></h1>
            </header>
            <StatisticResults :items="items" />
        </template>
    </Layout>
</template>

<script>
import { fetchOrderStatistic } from '../../api/orders';
import Layout from '@speechki-frontend/shared/ui/layout/Layout';
import Spinner from '@speechki-frontend/shared/ui/Spinner';
import { StatisticResults } from '@/statistic/components';

export default {
    name: 'OrderStylesheetPage',
    components: {
        Layout,
        Spinner,
        StatisticResults,
    },
    data() {
        return {
            loading: false,
            items: [],
        };
    },
    computed: {
        orderId() {
            const { id } = this.$route.params;
            return id;
        },
        orderRoute() {
            return {
                name: 'orders-id',
                params: { id: this.orderId },
            };
        },
    },
    async created() {
        try {
            this.items = await fetchOrderStatistic(this.orderId);
        } catch (err) {
            console.log(err);
        } finally {
            this.loading = false;
        }
    },
};
</script>
